export default __webpack_public_path__ + "media/zurb/img/playground/concept-experiment-cheatsheet-img-07705a7855dcd703b44fad35e890207c.png";